import Cookies from "js-cookie";
/**
 *手动填写院系 需要手动生成ID
 * @param max 最大值
 * @param min 最小值
 * @returns {*}
 */
export function randomNum (max, min) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

// 弹窗谈起禁止页面滑动
export function disSlide() {
  const body = document.querySelector('body')
  body.style.paddingRight = '17px'
  body.style.overflow = 'hidden'
}
export function initSlide() {
  const body = document.querySelector('body')
  body.style.paddingRight = '0'
  body.style.overflow = 'auto'
}
// 学生是否登录
export function isStudentLogin() {
  if(Cookies.get('user_id') && Cookies.get('login_type') == 'student') {
    return true
  }
  return false
}
// 高校是否登录
export function isSchoolLogin() {
  if(Cookies.get('user_id') && Cookies.get('login_type') == 'school') {
    return true
  }
  return false
}
//企业是否登录
export function isCompanyLogin() {
  if(Cookies.get('com_key_user') && Cookies.get('login_type') == 'company') {
    return true
  }
  return false
}
//渠道是否登录
export function isChanelLogin() {
  if(Cookies.get('channel_userid') && Cookies.get('login_type') == 'channel') {
    return true
  }
  return false
}
//默认头像处理
export const dealDefaultAvatar = (user_id, gender) => {
  let avatarUrl = ''
  if (gender == 1) {
    let womanimgs = [
      '//img.applyoffer.com/resume/avatar/v2/woman_1.png',
      '//img.applyoffer.com/resume/avatar/v2/woman_2.png',
      '//img.applyoffer.com/resume/avatar/v2/woman_3.png'
    ]

    avatarUrl = womanimgs[user_id % 3]
  } else {
    let manimgs = [
      '//img.applyoffer.com/resume/avatar/v2/man_1.png',
      '//img.applyoffer.com/resume/avatar/v2/man_2.png',
      '//img.applyoffer.com/resume/avatar/v2/man_3.png'
    ]
    avatarUrl = manimgs[user_id % 3]
  }

  return avatarUrl
}

// 时间排序
export const ReverseRankingDate = (timeData, p) => {
  for (var i = 0; i < timeData.length - 1; i++) {
     for (var j = 0; j < timeData.length - 1 - i; j++) {
          if (Date.parse(timeData[j][p]) < Date.parse(timeData[j+1][p])) {
              var temp = timeData[j];
              timeData[j] = timeData[j + 1];
              timeData[j + 1] = temp;
          }
     }
  }
  return timeData;
}

export const formatNumber = (num) => {
  if(num !== -1){
    return num >= 1e3 ? (num / 1e3) + 'k' : num >= 1e4 ? (num / 1e4) + 'w' : num
  }
}

// 修改页面meta信息
export const setMeta = (title, keyWord, desc) => {
  document.title = title || '';
  document.querySelector("meta[name='keyword']").setAttribute('content', keyWord || '');
  document.querySelector("meta[name='description']").setAttribute('content', desc || '');
}
export const isMac = () => {
  return /macintosh|mac os x/i.test(navigator.userAgent)
}



// WEBPACK FOOTER //
// ./src/utils/utils.js